module.exports = __webpack_public_path__ + "static/media/logo.a7ccc62b.png";